import * as React from "react";

function SvgTheTradeDesk(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      version="1.1"
      viewBox="0 0 22 22"
      preserveAspectRatio="xMidYMid meet"
      {...{ ...props, ref }}
    >
      <g fill="currentColor">
        <path d="M5.84,15.85v4.61C2.43,18.69.11,15.14.11,11.04c0-1.5.31-2.93.88-4.22h4.33c-.91,1.16-1.46,2.63-1.46,4.22,0,1.87.75,3.57,1.97,4.81Z"></path>
        <path d="M21.31,11.04c0,5.86-4.75,10.6-10.6,10.6-.64,0-1.26-.06-1.87-.17v-3.85c.59.17,1.22.26,1.87.26,3.78,0,6.85-3.07,6.85-6.85,0-1.88-.76-3.59-1.99-4.82V1.62c3.41,1.76,5.74,5.32,5.74,9.43Z"></path>
        <polygon points="4.78 .5 4.78 4.25 8.84 4.25 8.84 12.36 12.6 12.36 12.6 .5 4.78 .5"></polygon>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgTheTradeDesk);
